import { FormControl, FormLabel, Stack, Textarea, Typography } from '@healthinal/ui';
import { ReactNode } from 'react';
import { FieldPath, FieldValues, useFormContext } from 'react-hook-form';
import { AddressDtoAddressType } from '../../../../../api/generated/model';
import { InstitutionContactFields } from '../../../../../components/form/InstitutionContactFields.tsx';

interface ClinicalReportDoctorsFormProps<TFieldValues extends FieldValues> {
  doctorAddress: FieldPath<TFieldValues>;
  doctorContact: FieldPath<TFieldValues>;
  treatingDoctorAddress: FieldPath<TFieldValues>;
  treatingDoctorContact: FieldPath<TFieldValues>;
  notes: FieldPath<TFieldValues>;
  children?: ReactNode;
}
export function ClinicalReportDoctorsForm<TFieldValues extends FieldValues>({
  doctorAddress,
  doctorContact,
  treatingDoctorAddress,
  treatingDoctorContact,
  notes,
  children,
}: ClinicalReportDoctorsFormProps<TFieldValues>) {
  const formMethods = useFormContext<TFieldValues>();
  const { register } = formMethods;

  return (
    <Stack gap={2}>
      <Typography level={'title-lg'}>Kontakte</Typography>
      <InstitutionContactFields
        formMethods={formMethods}
        addressField={doctorAddress}
        contactField={doctorContact}
        addressLabel="Institution"
        contactLabel="Meldender Arzt"
        addressTypes={[AddressDtoAddressType.DOCTOR]}
        canChangeAddressType={false}
        clearContactOnAddressChange="always"
        contactClearOptions={false}
        useAllContactsList={true}
      />
      <InstitutionContactFields
        formMethods={formMethods}
        addressField={treatingDoctorAddress}
        contactField={treatingDoctorContact}
        addressLabel="Institution"
        contactLabel="Behandelnder Arzt"
        addressTypes={[AddressDtoAddressType.DOCTOR]}
        canChangeAddressType={false}
        clearContactOnAddressChange="always"
        contactClearOptions={false}
        useAllContactsList={true}
      />
      <FormControl>
        <FormLabel>
          <Typography>Bemerkungen</Typography>
        </FormLabel>
        <Textarea {...register(notes)} minRows={2} maxRows={4} />
      </FormControl>
      {children}
    </Stack>
  );
}
